<template>
  <div class="row" style="margin-bottom:5px;padding: 0px 5px;">
    <div v-if="fieldInfo.type == types.INPUT">
      <input-box
        :data="fieldInfo"
        :value="valinfo"
        :option="optionInfo"
        :read="readOnly"
        @error_msg="onErrorMsg"
        @on_update="onUpdate"
      ></input-box>
    </div>
    <div v-else-if="fieldInfo.type == types.EMAIL">
      <email-box
        @on_update="onUpdate"
        :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></email-box>
    </div>
    <div v-else-if="fieldInfo.type == types.SELECT_BOX">
      <select-box 
        @on_update="onUpdate"
        :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></select-box>
    </div>
    <div v-else-if="fieldInfo.type == types.SELECT_BOX2">
      <select-box2
        @on_update="onUpdate"
        :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></select-box2>
    </div>
    <div v-else-if="fieldInfo.type == types.SELECT_BOX3">
      <select-box3
        @on_update="onUpdate"
        :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></select-box3>
    </div>
    <div v-else-if="fieldInfo.type == types.SELECT_BOX4">
      <select-box4
        @on_update="onUpdate"
        :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></select-box4>
    </div>
    <div v-else-if="fieldInfo.type == types.DATE_PICKER  || fieldInfo.type == types.CURRENT_TIME">
      <input-box
        v-if="fakeDate()"
        :data="fieldInfo"
        :value="valinfo"
        :option="optionInfo"
        :read="readOnly"
      ></input-box>
      <date-box v-else :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></date-box>
    </div>
    <div v-else-if="fieldInfo.type == types.DATETIME_PICKER ">
      <input-box
        v-if="fakeDate()"
        :data="fieldInfo"
        :value="valinfo"
        :option="optionInfo"
        :read="readOnly"
      ></input-box>
      <datetime-box v-else :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></datetime-box>
    </div>
    <div v-else-if="fieldInfo.type == types.PASSWORD">
      <password-box :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></password-box>
    </div>
    <div v-else-if="fieldInfo.type == types.RADIO_BUTTON">
      <radio-button :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></radio-button>
    </div>
    <div v-else-if="fieldInfo.type == types.TEXT_AREA">
      <text-area :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></text-area>
    </div>
    <div v-else-if="fieldInfo.type == types.CHECKBOX">
      <checkbox :data="fieldInfo" :value="valinfo" :option="optionInfo" :read="readOnly"></checkbox>
    </div>
    <div v-else-if="fieldInfo.type == types.SPACE">
      <div class="form-group esma_form_group">
        <br />
      </div>
    </div>

    <div
      v-show="showError"
      :style="'color:white;margin:2px 0px;padding:2px 5px;text-align: end; width: 90%;float: right;background-color:' + ((errorMode == 'restrict')?'#de5201;':'orange;')"
    >{{errorMsg}}</div>
  </div>
</template>

<script>
import Vue from "vue";
import inputBox from "@/components/fields/input-box";
import passwordBox from "@/components/fields/password-box";
import selectBox from "@/components/fields/select-box";
import selectBox2 from "@/components/fields/select-box2";
import selectBox3 from "@/components/fields/select-box3";
import selectBox4 from "@/components/fields/select-box4";
import radioBox from "@/components/fields/radio-button";
import dateBox from "@/components/fields/date-box";
import datetimeBox from "@/components/fields/datetime-box";
import textArea from "@/components/fields/text-area";
import checkbox from "@/components/fields/checkbox";
import email from "@/components/fields/email-box";
import { filed_types } from "@/constants/field_types";

import debug from "debug";
var debug_form_field = debug("__esma:form-field");

export default {
  components: {
    "input-box": inputBox,
    "password-box": passwordBox,
    "select-box": selectBox,
    "select-box2": selectBox2,
    "select-box3": selectBox3,
    "select-box4": selectBox4,
    "radio-button": radioBox,
    "date-box": dateBox,
    "datetime-box": datetimeBox,
    "text-area": textArea,
    "checkbox": checkbox,
    "email-box":email
  },
  data() {
    return {
      //  testVal:"..."
      error_msg: "",
      show_error: false,
      show_error_mode: "none"
    };
  },
  computed: {
    styleForError() {},
    errorMode: {
      get() {
        return this.show_error_mode;
      },
      set(v) {
        this.show_error_mode = v;
      }
    },
    errorMsg: {
      get() {
        return this.error_msg;
      },
      set(v) {
        this.error_msg = v;
      }
    },
    showError: {
      get() {
        return this.show_error;
      },
      set(v) {
        this.show_error = v;
      }
    },
    types() {
      return filed_types;
    },
    fieldInfo() {
      var ret = this.$props.data;
      debug_form_field("fieldInfo.type", ret.type, ret);
      return ret;
    },
    optionInfo() {
      debug_form_field(
        "this.props.option",
        this.$props.data.id,
        JSON.stringify(this.$props.option)
      );
      return this.$props.option;
    },
    valinfo() {
      if (
        typeof this.$props.val == "undefined" ||
        this.$props.val == null ||
        this.$props.val.length == 0
      ) {
        // debug_form_field("empty value",this.$props.val, this.$props.data.type)
        return " ";
      } else {
        return this.$props.val;
      }
    },
    readOnly() {
      return this.$props.read || this.$props.data.read_only == true;
    }
  },
  methods: {
    onUpdate(o){
      this.$emit("on_update",o);
    },
    onErrorMsg(err_obj) {
      this.errorMsg = err_obj.msg;
      this.showError = err_obj.msg && err_obj.msg.length > 0;
      this.errorMode = err_obj.error_mode;
      if (err_obj.error_mode == "warning") {
        this.$emit("validationRestriction", {
          active: false,
          id: this.fieldInfo.id
        });
      } else if (err_obj.error_mode == "restrict") {
        var ative = false;
        if (err_obj.msg && err_obj.msg.length > 0) {
          ative = true;
        }
        this.$emit("validationRestriction", {
          active: ative,
          id: this.fieldInfo.id
        });
      }
      console.log(
        "this.errorMode",
        err_obj.error_mode,
        this.errorMode,
        err_obj
      );
    },
    fakeDate() {
      return Vue.localStorage.get("fakeDate") || false;
    }
  },
  mounted() {},
  props: {
    read: { default: true },
    data: { default: {} },
    val: { default: "" },
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
<style>
.esma_form_label {
  background-color: #b4d5f1 !important;
  margin: 2px 0px !important;
  padding: 4px !important;
  font-size: 11px !important;
  text-align: center !important;
}

.esma_form_group {
  padding: 0px !important;
  margin: 0px !important;
}
.form-control {
  _height: 24px !important;
}
.vdp-datepicker__calendar-button,
.vdp-datepicker__clear-button {
  padding: 0px 12px !important;
}
.vdp-datepicker {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// form-field.vue?d87ef1d8